import { loadTranslations } from '@/services/translations';

const translations = {
  data() {
    return {
      languages: [
        {
          id: 'bs',
          title: 'Bosanski',
          flag: 'ba',
          shortTitle: 'bs',
        },
        {
          id: 'hr',
          title: 'Hrvatski',
          flag: 'hr',
          shortTitle: 'hr',
        },
        {
          id: 'srLatn',
          title: 'Srpski (lat)',
          flag: 'sr',
          shortTitle: 'sr',
        },
        {
          id: 'srCyrl',
          title: 'Српски (ћир)',
          flag: 'sr',
          shortTitle: 'cp',
        },
        {
          id: 'en',
          title: 'English',
          flag: 'us',
          shortTitle: 'eng',
        },
      ],
      selectedLang: localStorage.getItem('langId') || localStorage.getItem('defaultLangId'),
    };
  },
  computed: {
    useDefaultLanguage() {
      return this.$store.getters.useDefaultLanguage;
    },
    defaultLanguage() {
      return this.$store.getters.defaultLanguage;
    },
    defaultLanguages() {
      return this.$store.getters.languages;
    },
    currentLang() {
      if (this.useDefaultLanguage && this.defaultLanguage) {
        return this.defaultLanguage;
      }
      return this.selectedLang;
    },
    lang() {
      return this.languages.find((item) => item.id === this.currentLang);
    },
    translations() {
      return loadTranslations(this.currentLang);
    },
  },
  methods: {
    setLanguage(langId) {
      if (langId === this.selectedLang) return;
      const lang = this.languages.find((item) => item.id === langId);
      this.selectedLang = lang ? lang.id : this.defaultLanguage;
      localStorage.setItem('langId', this.selectedLang);
      window.location.reload();
    },
  },
};

export default translations;
